import styled, { keyframes, css } from 'styled-components';
import { devices } from '../../../constants/devices';
import { isTablet } from '../../../utils/detectDevices';

const pulse = keyframes({
  '0%': { opacity: 0 },
  '60%': { opacity: 1 },
  '100%': { opacity: 0 },
});

export const NavigNodeColorBar = styled.div((props) => ({
  height: 'calc(100% - 10px)',
  borderRadius: '2px',
  left: '5px',
  position: 'absolute',
  top: '5px',
  width: '3px',
  backgroundColor:
    props.$nodeColor && props.$nodeColor !== 'blinking'
      ? props.$nodeColor
      : 'var(--ds-border-base)',
  // normal JSON object here — no animation unless blinking
  ...(props.$nodeColor === 'blinking' && {
    willChange: 'opacity',
  }),
}));

// extra animation styles injected via css`` wrapper
export const BlinkingNodeColorBar = styled(NavigNodeColorBar)`
  ${({ $nodeColor }) =>
    $nodeColor === 'blinking' &&
    css`
      animation: ${pulse} 1.4s ease-in-out infinite;
      @media (prefers-reduced-motion: reduce) {
        animation: none;
      }
    `}
`;
//------------------------------------------------------------------------------

const getWidthNavigNodeContainerStyle = (props) => {
  if (props.$dragging && !isTablet) return '10px';
  return props.$zoom < 70 ? `${props.$width * 2}px` : `${props.$width}px`;
};

const getBoxShadowNavigNodeContainerStyle = (props) => {
  if (props.$displayMode === 'stack')
    return '0 1px 2px rgba(0,0,0,0.02), 0 2px 4px rgba(0,0,0,0.04)';
  if (props.$zoom < 70) return '0px 0px 0px';
  return props.$isNodeSelected
    ? '2px 2px 3px 0px rgba(0,0,0,0.10)'
    : '1px 1px 1px 0px rgba(0,0,0,0.05)';
};

export const NavigNodeWrapper = styled.div({
  zIndex: '19999',
  width: '200px',
  height: '200px',

  '.containerMiniMenuAction': {
    display: 'none',
  },

  '&:hover .containerMiniMenuAction': {
    display: 'block',
  },
});

function hashStringToAngle(str) {
  if (!str) return 0;
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  // valeur pseudo-aléatoire + ou - 1.5
  return (hash % 2 === 0 ? 1 : -1) * 1.5;
}

export const NavigNodeContainerStyle = styled.div.attrs((props) => ({
  style: {
    borderRadius:
      props.$displayMode === 'stack'
        ? '0px'
        : props.$isNodeOnActivePanel
        ? '7px'
        : '50%',
    left: `${props.$isNodeOnActivePanel ? props.$left : 20}px`,
    top: `${props.$top}px`,
    padding: '4px 0px 2px 10px',
  },
}))({
  border: (props) =>
    props.$displayMode === 'stack' ? 'none' : '1px solid #99999944',
  borderBottom: (props) =>
    props.$displayMode === 'stack' ? '1px solid #BBBBBB' : '',
  display: (props) => (props.$dragging && !isTablet ? 'none' : ''),
  verticalAlign: 'middle',
  lineHeight: '100%',

  opacity: (props) => (props.$isNodeOutsidePane ? '0' : '1'),
  pointerEvents: (props) =>
    props.$isNodeOutsidePane || props.$dragging ? 'none' : 'auto',
  overflow: (props) => (props.$dragging ? 'hidden' : 'visible'),
  transition: isTablet
    ? 'none'
    : 'left 0.2s, top 0.5s, opacity 0.3s, height 0.9s, width 0.9s, transform 0.3s',
  width: (props) => getWidthNavigNodeContainerStyle(props),
  zIndex: 5001,
  backgroundColor: (props) =>
    props.$displayMode === 'stack'
      ? 'var(--ds-bg-base-20)'
      : 'var(--ds-bg-base)',
  boxShadow: (props) => getBoxShadowNavigNodeContainerStyle(props),
  touchAction: (props) => (props.$isHaveChildNode ? 'pax-x' : 'pan-left pan-y'),
  // transition: isTablet && 'none',
  [devices.mobileL]: {
    zIndex: 100000000,
    maxWidth: (props) => `${props.$width}px`,
  },
  transform: (props) =>
    props.$notSet ? `rotate(${hashStringToAngle(props.$nodeId)}deg)` : '',
});
//------------------------------------------------------------------------------
export const DivStickersStyle = {
  position: 'absolute',
  left: '5px',
  top: '0px',
};
//------------------------------------------------------------------------------
export const DivStickerStyle = {
  border: '1px solid #333',
  borderRadius: '0px 0px 0px 3px',
  display: 'inline-block',
  height: '4px',
  marginRight: '2px',
  width: '16px',
};
export const BorderHightLight = styled.div({
  position: 'absolute',
  width: 'calc(100% + 4px)',
  height: 'calc(100% + 4px)',
  top: -2,
  left: -2,
  borderRadius: 5,
  border: (props) => `2px solid ${props.$borderColor || 'red'}`,
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.3)',
  opacity: (props) => (props.$active ? 0.3 : 0),
  transition: 'opacity 0.6s',
  pointerEvents: (props) => (props.$active ? '' : 'none'),
});
